'use strict';

const LS_LAST_LOCALE_KEY = 'last-site-locale';

/**
 * Clears the search widget's persisted state (origin/destination inputs, dates, etc.)
 * when a user switches between language variants of the same site
 * (e.g. www.edreams.sa <-> www.edreams.sa/en).
 *
 * The React search widget uses redux-persist to save state in sessionStorage under
 * the key 'persist:root'. Without this, switching languages carries over the previous
 * session's search inputs into the new language context.
 *
 * The last visited locale is tracked in localStorage so the switch can be detected
 * across page loads.
 */
module.exports = function clearPersistOnLangSwitch() {
    const currentLocale = Odigeo.SessionScope.locale;

    if (!currentLocale) return;

    try {
        const lastLocale = Odigeo.Storage.get(LS_LAST_LOCALE_KEY);

        if (lastLocale && lastLocale !== currentLocale) {
            Odigeo.Session.remove('persist:root');
        }

        Odigeo.Storage.set(LS_LAST_LOCALE_KEY, currentLocale);
    } catch (_e) {
        //
    }
};
